/** @format */

const caseTemplate = '58b2f3a35d59f31e1345b48a';
const matterTemplate = '58b2f3a35d59f31e1345b4a4';

const renderableTemplates = {
  judgement: '58b2f3a35d59f31e1345b4ac',
  admissibilityReport: '58b2f3a35d59f31e1345b479',
  orderOfThePresident: '58b2f3a35d59f31e1345b482',
  orderOfTheCourt: '58b2f3a35d59f31e1345b471',
  letterOfSubmission: '59ee461f40f4a54920bd9b87',
  meritsReport: '5a4d294c79f3f44b101e2816',
  fondo: '59ee427f40f4a54920bd9b67',
  hearing: '5a68ba41e1525a0c66291e22'
};

const datePropertyOverrides = {

  // hearing: 'fecha_de_la_audiencia',
};
export { caseTemplate, matterTemplate, renderableTemplates, datePropertyOverrides };